var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableGame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 506.54 506",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m55.438 389.66 49.421-337.738a86.097 86.097 0 0 1 4.387-17.242l-48.414 2.457c-35.3 1.793-62.46 31.86-60.672 67.16L17.465 445.19c1.726 34.012 29.785 60.715 63.84 60.754 1.105 0 2.21-.027 3.324-.082l130.351-6.617-87.464-12.8c-46.598-6.876-78.84-50.173-72.079-96.786zm0 0",
    fill: "#4466ef",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.922 63.113a63.598 63.598 0 0 0-42.063-25.097L198.56.953c-34.973-5.121-67.477 19.082-72.594 54.059L76.543 392.746c-4.777 34.887 19.266 67.172 54.059 72.59l253.304 37.066c34.887 4.782 67.172-19.261 72.59-54.058l49.426-337.735a63.586 63.586 0 0 0-12-47.496zM375.258 285.141c-30.29 22.554-72.203 41.691-87.664 48.406-3.703 1.61-8 .98-11.09-1.625-12.887-10.86-47.559-41.203-70.117-71.492-54.07-72.594 42.71-144.668 96.777-72.078 72.602-54.059 144.672 42.73 72.066 96.789zm0 0",
    fill: "#4466ef",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableGame);
export default __webpack_public_path__ + "static/media/TableGame.037464c3fdd14495a7b9098e434e4818.svg";
export { ForwardRef as ReactComponent };